import { styled } from 'linaria/react';
import { css } from 'linaria';

export const AddToCartWrapper = styled.div`
  position: sticky;
  top: 72px;
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  box-sizing: border-box;
  width: 372px;
  height: auto;
  padding: var(--space-400);
  background-color: var(--background-secondary);
  border-radius: 8px;

  @media (max-width: 1024px) {
    width: 100%;
  }
  @media (--only-mobile) {
    position: relative;
    height: auto;
    padding: var(--space-300);
  }
`;

export const ResultSumWrapper = styled.div<{ isLast?: boolean }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => (props.isLast ? 'var(--space-100)' : '0px')};
`;

export const RegionMismatchContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-50);
`;

export const PriceResultClassname = css`
  width: auto;
`;
